import { render, staticRenderFns } from "./PickupPoint.vue?vue&type=template&id=271f0a44"
import script from "./PickupPoint.vue?vue&type=script&lang=js"
export * from "./PickupPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports